import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import IconSvg from "../IconSvg";

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(10);
  const isTurkishSelected = i18next.language === "tr";

  const handleLanguageChange = (lang) => {
    i18next.changeLanguage(lang).catch((err) => {
      console.log(err);
    });
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  // Calculate progress percentage (from 10 to 0, so we reverse it)
  const progressPercentage = ((10 - countdown) / 10) * 100;
  const circleRadius = 35;
  const circleCircumference = 2 * Math.PI * circleRadius;
  const progressOffset = circleCircumference - (progressPercentage / 100) * circleCircumference;

  return (
    <Container fluid className="d-flex align-items-center justify-content-center" style={{ minHeight: "70vh" }}>
      {/* Language Switcher - Positioned at top right */}
      <div className="position-absolute" style={{ top: "20px", right: "20px" }}>
        <Row className="align-items-center">
          <Col xs="auto" className="px-1">
            <Button
              variant="link"
              className={`p-1 border-0 ${isTurkishSelected ? "opacity-100" : "opacity-50"}`}
              onClick={() => handleLanguageChange("tr")}
              style={{ textDecoration: "none" }}
            >
              <IconSvg icon="flag-tr" height={24} width={24} />
            </Button>
          </Col>
          <Col xs="auto" className="px-0">
            <span style={{ color: "#6c757d" }}>|</span>
          </Col>
          <Col xs="auto" className="px-1">
            <Button
              variant="link"
              className={`p-1 border-0 ${!isTurkishSelected ? "opacity-100" : "opacity-50"}`}
              onClick={() => handleLanguageChange("en")}
              style={{ textDecoration: "none" }}
            >
              <IconSvg icon="flag-uk" height={24} width={24} />
            </Button>
          </Col>
        </Row>
      </div>

      <Row className="text-center">
        <Col>
          <div style={{ fontSize: "120px", fontWeight: "bold", color: "#6c757d", marginBottom: "20px" }}>404</div>
          <h2 style={{ color: "#343a40", marginBottom: "15px" }}>{t("notFound.pageNotFound", "Page Not Found")}</h2>
          <p style={{ color: "#6c757d", fontSize: "18px", marginBottom: "20px" }}>
            {t("notFound.pageNotFoundMessage", "Sorry, the page you are looking for doesn't exist or has been moved.")}
          </p>

          {/* Countdown Timer with Circular Progress */}
          <div className="d-flex justify-content-center align-items-center" style={{ marginBottom: "30px" }}>
            <div className="position-relative d-flex justify-content-center align-items-center">
              <svg width="80" height="80" style={{ transform: "rotate(-90deg)" }}>
                {/* Background circle */}
                <circle cx="40" cy="40" r={circleRadius} stroke="#e9ecef" strokeWidth="4" fill="transparent" />
                {/* Progress circle */}
                <circle
                  cx="40"
                  cy="40"
                  r={circleRadius}
                  stroke="#007bff"
                  strokeWidth="4"
                  fill="transparent"
                  strokeDasharray={circleCircumference}
                  strokeDashoffset={progressOffset}
                  strokeLinecap="round"
                  style={{
                    transition: "stroke-dashoffset 1s linear",
                  }}
                />
              </svg>
              <div
                className="position-absolute d-flex flex-column justify-content-center align-items-center"
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "#007bff",
                }}
              >
                <div>{countdown}</div>
              </div>
            </div>
            <div style={{ marginLeft: "15px", color: "#6c757d", fontSize: "16px" }}>
              {t("notFound.redirectingIn", "Redirecting to home in")} {countdown} {t("notFound.seconds", "seconds")}
            </div>
          </div>
          <div className="d-flex justify-content-center gap-3">
            <Button
              variant="primary"
              onClick={handleGoHome}
              style={{
                backgroundColor: "#007bff",
                borderColor: "#007bff",
                padding: "10px 30px",
                fontSize: "16px",
              }}
            >
              {t("notFound.goHome", "Go to Home")}
            </Button>
            <Button
              variant="outline-secondary"
              onClick={handleGoBack}
              style={{
                padding: "10px 30px",
                fontSize: "16px",
              }}
            >
              {t("notFound.goBack", "Go Back")}
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
